















import Vue, { PropType } from 'vue';

export type DataType = {
  style: any;
}
export default Vue.extend({
  name: 'GAuthTextareaField',
  props: {
    value: { type: String as PropType<string>, required: true },
    rows: { type: Number as PropType<number>, required: true },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    error: { type: String as PropType<string>, default: '' },
    maxlength: { type: Number as PropType<number>, required: true },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
});
